import { autoExtractUserInfo } from '@/api/crm/customer';
const phoneFillFieldNames = ['手机', '电话', '联系'];
const addressFillFieldNames = ['地址'];
const wechatFillFieldNames = ['微信'];
export default {
  debounce(fn, interval = 1000) {
    let timer = null;
    return function() {
      clearTimeout(timer);
      let context = this;
      let args = arguments;
      timer = setTimeout(function() {
        fn.call(context, ...args);
      }, interval);
    };
  },
  log(str = 'log', params = '') {
    console.log(str, params);
  },
  catchEvent(event) {
    event.preventDefault();
    event.stopPropagation();
  },
  // 深拷贝
  cloneDeep(target, hash = new WeakMap()) {
    // 额外开辟一个存储空间WeakMap来存储当前对象
    if (target === null) return target; // 如果是 null 就不进行拷贝操作
    if (target instanceof Date) return new Date(target); // 处理日期
    if (target instanceof RegExp) return new RegExp(target); // 处理正则
    if (target instanceof HTMLElement) return target; // 处理 DOM元素

    if (typeof target !== 'object') return target; // 处理原始类型和函数 不需要深拷贝，直接返回

    // 是引用类型的话就要进行深拷贝
    if (hash.get(target)) return hash.get(target); // 当需要拷贝当前对象时，先去存储空间中找，如果有的话直接返回
    const cloneTarget = new target.constructor(); // 创建一个新的克隆对象或克隆数组
    hash.set(target, cloneTarget); // 如果存储空间中没有就 以当前要拷贝的内容为键 存进 hash 里

    Reflect.ownKeys(target).forEach(key => {
      // 引入 Reflect.ownKeys，处理 Symbol 作为键名的情况
      if (key === '__ob__') return; // 不拷贝vue的Observer
      cloneTarget[key] = this.cloneDeep(target[key], hash); // 递归拷贝每一层
    });
    return cloneTarget; // 返回克隆的对象
  },
  throttle(fn, interval = 1000) {
    let enterTime = 0; //触发的时间
    return function() {
      let context = this;
      let backTime = new Date(); //第一次函数return即触发的时间
      if (backTime - enterTime > interval) {
        fn.call(context, ...arguments);
        enterTime = backTime; //赋值给第一次触发的时间，这样就保存了第二次触发的时间
      }
    };
  },
  async autoFill(e) {
    const originalStr = e;
    // 17623220537 百度-苏巧宗 辽宁沈阳
    // 微信 手机 来源 地址 (顺序可调换)
    // const phoneReg = /(?<!\d)[0-9]{11}(?!\d)/;
    e = e.trim();
    const wechatReg = new RegExp('[^\\u4e00-\\u9fa5\\s]*', 'g');
    const phoneReg = new RegExp('(?<!\\d)[0-9]{11}(?!\\d)');
    let sourceArr = this.fieldList.reduce((result, outer) => {
      if (result.length) return result;
      else {
        return outer.reduce((data, item) => {
          if (data.length) return data;
          else if (item.form_type == 'cascader' && item.field == 'source') {
            return item.setting;
          } else {
            return data;
          }
        }, []);
      }
    }, []);
    sourceArr = sourceArr.reduce((result, item) => {
      result.push(
        ...item.children.map(child => {
          return { name: child.label, value: [item.value, child.value] };
        })
      );
      return result;
    }, []);

    const phone = phoneReg.exec(e) && phoneReg.exec(e)[0] ? phoneReg.exec(e)[0] : null;
    if (phone) e = e.replace(phone, '').trim();
    let wechat =
      e.match(wechatReg) && e.match(wechatReg).filter(item => item).length
        ? e.match(wechatReg).filter(item => item)[0]
        : null;
    // 不能是纯数字
    if (wechat && /^(?![0-9]+$)[0-9A-Za-z!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{6,}$/.test(wechat))
      e = e.replace(wechat, '').trim();
    else wechat = '';
    // const sourceReg = /\S*((?<!\d)\d{0,10}(?!\d))\S*/g;
    const sourceReg = new RegExp('\\S*((?<!\\d)\\d{0,10}(?!\\d))\\S*', 'g');
    const source = sourceArr.find(s => {
      return (e.match(sourceReg) ? e.match(sourceReg).filter(item => item) : []).find(item => {
        if (s.name.includes(item)) {
          e = e.replace(item, '').trim();
          return true;
        }
      });
    });

    if (source) this.fieldForm.source = source.value;
    if (phone || phoneReg.test(wechat)) {
      phoneFillFieldNames
        .map(str => this.fieldList.flat().find(item => item.name.includes(str)))
        .filter(item => item)
        .forEach(item => {
          console.log('内容', item.field, item.fieldName, item.name);
          this.fieldForm[item.field] = phone || wechat;
        });
    }
    if (wechat || phone) {
      this.fieldList
        .reduce((result, outer) => {
          let data = outer.filter(item => {
            return wechatFillFieldNames.filter(str => {
              return item.name.includes(str) && item.form_type == 'text';
            }).length;
          });
          return [...result, ...data];
        }, [])
        .forEach(item => {
          this.fieldForm[item.field] = wechat || phone;
        });
    }
    if (e) {
      // 之前提取后剩余字符串
      this.fieldList
        .reduce((result, outer) => {
          let data = outer.filter(item => {
            return addressFillFieldNames.filter(str => {
              return item.name.includes(str);
            }).length;
          });
          return [...result, ...data];
        }, [])
        .forEach(item => {
          this.fieldForm[item.field] = e;
        });
      if (this.fieldForm.hasOwnProperty('customer_address')) {
        if (this.$refs.address && this.$refs.address.length) {
          this.$refs.address[0].initInfo({
            address: ['', '', ''],
            // lat = 111,
            // lng = 111,
            detail_address: e,
            location: e
          });
        }
      }
    }
    try {
      const res = await autoExtractUserInfo(originalStr);
      console.log(res,'123',this.fieldForm);
      if (res.code == 200) {
        if (res.data.customer_address.address && res.data.customer_address.address.length) {
          if (this.fieldForm.hasOwnProperty('customer_address')) {
            if (this.$refs.address && this.$refs.address.length) {
              this.$refs.address[0].initInfo({
                address: [...res.data.customer_address.address],
                detail_address: this.fieldForm.customer_address.detail_address,
                location: this.fieldForm.customer_address.location,
              });
            }
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  },
  testEvent(e) {
    console.log(e);
  },
  phoneFillFieldNames,
  addressFillFieldNames,
  wechatFillFieldNames
};
